import { logger } from '@sendpayments/js-utils';

export const reduce = (state, action) => {
  const { payload } = action;
  const { key, initialState } = payload || {};

  if (!payload) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/INIT_REMOTE_DATA. payload need to be passed`, action);
  }

  if (!key) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/INIT_REMOTE_DATA. key need to be passed`, action);
  }

  if (!initialState) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/INIT_REMOTE_DATA. initialState need to be passed`, action);
  }

  const currentRemoteData = state[key];
  if (!currentRemoteData) {
    logger.log('@sendpayments/react-shared/remote-data', `reducer/INIT_REMOTE_DATA. Initializing state for ${key}.`, action);

    if (!state[key]) {
      // eslint-disable-next-line
      state[key] = {};
    }

    return {
      ...state,
      [key]: {
        loading: false,
        data: initialState,
        failed: false,
        initialized: true,
        invalidate: false,
        fetching: false,
        lastUpdated: +new Date(),
        offline: false,
      },
    };
  }

  logger.info('@sendpayments/react-shared/remote-data', `reducer/INIT_REMOTE_DATA. ${key} was already initialized.`, {
    message: 'Your are trying to initialize the same remote data more than once, place review your call order',
    action,
  });

  return state;
};
